import { ref } from '@vue/composition-api'

export default () => {
  const search = ref('')

  const setSearch = (newSearch) => (search.value = newSearch)

  return {
    search,
    setSearch
  }
}
